import React from 'react'
import {
    MessagingConversation,
    MessagingMessage,
    usePostMessages,
} from '@sugg-gestion/ubidreams-react-suggpro'
import { useStyles } from '../../views/messaging/styles.css'
import Grid from '@material-ui/core/Grid/Grid'
import { Field, Form } from 'react-final-form'
import i18next from 'i18next'
import { Button, CircularProgress } from '@material-ui/core'
import SendIcon from '@material-ui/icons/Send'
import { MessageFormState } from './privateMessageForm'
import { FormApi } from 'final-form'
import { PageType, useApiErrors } from 'core/services/suggPro/useApiErrors'

interface Props {
    conversation: MessagingConversation
    comment: MessagingMessage
}

const ReplyPostCommentForm: React.FC<Props> = ({ conversation, comment }) => {
    const classes = useStyles()
    const { displayError } = useApiErrors()

    // Post message
    const { postMessage, inProgressSendMessage } = usePostMessages()

    // Handle for when the key enter is presse, the form is submitting. Use shift + enter to make a new line
    const keyEnterEvent = (e: React.KeyboardEvent, submitHandle: any) => {
        const keyCode = e.which || e.keyCode
        // Key enter pressed
        if (keyCode === 13 && !e.shiftKey) {
            // Don't generate a new line
            e.preventDefault()
            submitHandle()
        }
    }

    // Handle submit form
    const handleSendComment = (
        values: MessageFormState,
        form: FormApi<MessageFormState, Partial<MessageFormState>>,
    ) => {
        if (values.text) {
            if (comment.parentId) {
                values.parentId = comment.parentId
            } else {
                values.parentId = comment.messageId
            }

            // Send the message
            const sendMessageResponse = postMessage({
                establishment: conversation.establishment,
                conversation: conversation.id,
                parentId: values.parentId ?? null,
                text: values.text,
            })

            sendMessageResponse
                .then((response) => {
                    // Reset the form when no error
                    form.reset()
                })
                .catch((error) => {
                    displayError(error, PageType.MESSAGING)
                })
        }
    }

    return (
        <Form onSubmit={handleSendComment}>
            {({ handleSubmit, submitting }) => (
                <form onSubmit={handleSubmit} noValidate>
                    <Grid container spacing={1}>
                        <Grid item xs={10}>
                            <Field
                                name={'text'}
                                component={'input'}
                                autoFocus={false}
                                onKeyPress={(e: React.KeyboardEvent) => keyEnterEvent(e, handleSubmit)}
                                className={classes.commentReplyTextarea}
                                placeholder={i18next.t('views.messaging.placeholderCommentReply', {
                                    name: comment.author.name,
                                })}
                                title={i18next.t('views.messaging.textareaHelper')}
                                disabled={inProgressSendMessage}
                                autoComplete={'off'}
                            />
                        </Grid>
                        <Grid item xs={2} className={classes.discussSendBtn}>
                            <Button
                                type={'submit'}
                                color={'primary'}
                                className={classes.sendButtonSquare}
                                title={i18next.t('views.messaging.send')}
                            >
                                {inProgressSendMessage ? (
                                    <CircularProgress style={{ color: 'rgba(0, 0, 0, 0.26)' }} size={20} />
                                ) : (
                                    <SendIcon />
                                )}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            )}
        </Form>
    )
}

export default ReplyPostCommentForm
